module.exports = __webpack_public_path__ + "img/infrastructure-11.8565e49d.png";